import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaSignOutAlt, FaUserPlus, FaEye, FaEyeSlash } from 'react-icons/fa';
import './Prapt_Aai.css'; // <--- IMPORTING PRAPT CSS TO KEEP DESIGN SAME
import topLogo from './logo-placeholder.png'; 

const AddNewUser = () => {
    const navigate = useNavigate();

    // --- 1. FORM STATE ---
    const [formData, setFormData] = useState({
        name: '',
        contactNo: '',
        password: '',
        email: '',
        role: '',
        address: ''
    });

    const [showPassword, setShowPassword] = useState(false);
    const [showExitModal, setShowExitModal] = useState(false);

    // --- 2. LOGOUT & BACK BUTTON LOGIC ---
    useEffect(() => {
        window.history.pushState(null, document.title, window.location.href);
        const handleBackButton = (event) => {
            window.history.pushState(null, document.title, window.location.href);
            setShowExitModal(true);
        };
        window.addEventListener('popstate', handleBackButton);
        return () => window.removeEventListener('popstate', handleBackButton);
    }, []);

    const handleYesLogout = () => {
        localStorage.removeItem('user');
        localStorage.removeItem('token'); 
        localStorage.removeItem('isLoggedIn');
        navigate('/'); 
    };

    const handleManualLogout = () => setShowExitModal(true);



    // --- 3. HANDLERS ---
    const handleChange = (e) => {
        const { name, value } = e.target;
        // Number validation for Contact No
        if (name === 'contactNo') {
            if (value === '' || /^[0-9\b]+$/.test(value)) {
                setFormData({ ...formData, [name]: value });
            }
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // --- 4. SUBMIT HANDLER (UPDATED TO CONNECT WITH BACKEND) ---
    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validation
        if (!formData.name || !formData.contactNo || !formData.password || !formData.role) {
            alert("Please fill Name, Contact, Password and Role");
            return;
        }

        try {
            // CALLING THE BACKEND API https://www.gpatrust.in/
            const response = await fetch('/api/dashboard/register-user', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: formData.name,
                    contactNo: formData.contactNo,
                    password: formData.password,
                    email: formData.email,
                    role: formData.role,
                    address: formData.address
                }),
            });

            const result = await response.json();

            if (result.success) {
                alert("✅ New Admin Registered Successfully!");
                // Clear the form
                setFormData({
                    name: '',
                    contactNo: '',
                    password: '',
                    email: '',
                    role: '',
                    address: ''
                });
            } else {
                alert("❌ Error: " + result.message);
            }

        } catch (error) {
            console.error("Registration Error:", error);
            alert("❌ Server Connection Error. Please try again.");
        }
    };

    return (
        <div className="details-container"> {/* Uses same yellow background */}

            {/* --- SIGNOUT BUTTON --- */}
            <button className="logout-btn" onClick={handleManualLogout}>
                <FaSignOutAlt /> 
                <span>Sign Out</span>
            </button>

            {/* --- MODAL --- */}
            {showExitModal && (
                <div className="modal-overlay">
                    <div className="modal-box">
                        <h3>Warning</h3>
                        <p>Do you want to Sign Out?</p>
                        <div className="modal-actions">
                            <button className="btn-confirm" onClick={handleYesLogout}>Yes</button>
                            <button className="btn-cancel" onClick={() => setShowExitModal(false)}>No</button>
                        </div>
                    </div>
                </div>
            )}

            {/* --- BACKGROUND SHAPES --- */}
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>

            {/* --- BRAND HEADER --- */}
            <div className="brand-header">
                <img src={topLogo} alt="Logo" className="brand-logo" />
                <div className="brand-text">
                    <h2>गायत्री परिवार</h2>
                    <h3>अलीराजपुर</h3>
                </div>
            </div>

            {/* --- PAGE HEADER --- */}
            <div className="details-header">
                <button className="back-btn" onClick={() => navigate('/home')}>
                   <FaArrowLeft /> Back
                </button>
                <h2><FaUserPlus /> Add New Admin</h2>
            </div>

            {/* --- FORM SECTION --- */}
            <div className="form-content-wrapper">
                <div className="prapt-form-card">
                    <form onSubmit={handleSubmit}>
                        
                        {/* 1. Name */}
                        <div className="prapt-form-group">
                            <input 
                                type="text" 
                                name="name" 
                                placeholder="Name" 
                                value={formData.name} 
                                onChange={handleChange} 
                                className="prapt-input" 
                            />
                        </div>

                        {/* 2. Contact No */}
                        <div className="prapt-form-group">
                            <input 
                                type="text" 
                                inputMode="numeric"
                                name="contactNo" 
                                placeholder="Contact No" 
                                value={formData.contactNo} 
                                onChange={handleChange} 
                                className="prapt-input"
                                maxLength="10" 
                            />
                        </div>

                        {/* 3. Password (With Toggle) */}
                        <div className="prapt-form-group" style={{position: 'relative'}}>
                            <input 
                                type={showPassword ? "text" : "password"} 
                                name="password" 
                                placeholder="Password" 
                                value={formData.password} 
                                onChange={handleChange} 
                                className="prapt-input"
                                style={{paddingRight: '45px'}} 
                            />
                            {/* Eye Icon positioned inside the input */}
                            <span 
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: 'absolute',
                                    right: '15px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                    color: '#666',
                                    zIndex: 10
                                }}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>
                        </div>

                        {/* 4. Email */}
                        <div className="prapt-form-group">
                            <input 
                                type="email" 
                                name="email" 
                                placeholder="Email Address" 
                                value={formData.email} 
                                onChange={handleChange} 
                                className="prapt-input" 
                            />
                        </div>

                        {/* 5. Role Dropdown */}
                        <div className="prapt-form-group">
                            <select 
                                name="role" 
                                value={formData.role} 
                                onChange={handleChange} 
                                className="prapt-input"
                            >
                                <option value="">Select Role</option>
                                <option value="Admin">Admin</option>
                                <option value="Manager">Manager</option>
                                <option value="Viewer">Viewer</option>
                            </select>
                        </div>

                        {/* 6. Address */}
                        <div className="prapt-form-group">
                            <input 
                                type="text" 
                                name="address" 
                                placeholder="Address" 
                                value={formData.address} 
                                onChange={handleChange} 
                                className="prapt-input" 
                            />
                        </div>

                        {/* Submit Button */}
                        <button type="submit" className="prapt-submit-btn">
                            ! ! REGISTER ! !
                        </button>
                    </form>
                </div>
            </div>

        </div>
    );
};

export default AddNewUser;